import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_13 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            d="M310.6,385.4c-0.7,3.5-1.9,12.9-6.2,15.3l14-1.4C318.7,388.5,311.2,382,310.6,385.4z"
          />
          <g>
            <path
              fill={colour0}
              d="M318.5,392c-2.8-0.8-7-4-7.1-5c-0.1-1,9.2-9.5,9.2-9.5L318.5,392z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M370,397.5c3-0.6,7.6-3.4,7.9-4.5c0.2-1-7.1-10.1-7.1-10.1L370,397.5z"
            />
            <path
              fill={colour0}
              d="M372.5,392.8c0.6-16.7-12.3-31.8-27.5-32.4c-15.2-0.6-28,12.5-28.6,29.2c-0.6,16.7,10.9,24.8,26.1,25.4
				C357.7,415.7,371.9,409.6,372.5,392.8z"
            />
            <path
              fill={colour2}
              d="M369.2,388.5c0.5-14.4-10.4-25.8-24.5-25.5c-14.1,0.3-25.9,12.2-26.4,26.6c-0.5,14.4,10.5,23.3,24.6,23
				C356.9,412.3,368.6,402.9,369.2,388.5z"
            />
            <path
              fill={colour3}
              d="M344.4,409.2c-14.1,0.3-25.1-9.4-24.5-23.7c0.1-2.3,0.5-4.6,1.1-6.7c-1.6,3.3-2.5,7-2.7,10.8
				c-0.5,14.4,10.5,24,24.5,23.7c11.9-0.2,22.2-7.6,25.4-18.6C363.9,403.4,354.8,409,344.4,409.2z"
            />
            <path
              fill={colour4}
              d="M356.8,391.3c0.3-7.1-5.5-13.1-13-13.4c-7.4-0.3-13.7,5.3-14,12.4c-0.3,7.1,5.5,13.1,13,13.4
				C350.3,404,356.6,398.4,356.8,391.3z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M377.9,392.9c-5.9-14.8-15.5-29.4-30.9-29.9c-13.9-0.5-32,10.3-35,23.8C326.4,372.3,358.9,373.1,377.9,392.9
				z"
            />
            <path
              fill={colour6}
              d="M312.9,384.1c3.1-10.9,37.8-27.1,63.7,5.8c0,0-4.1-29.8-30-30.8C316.4,358,312.9,384.1,312.9,384.1z"
            />
            <path
              fill={colour2}
              d="M359,392.7c0.1-2.6-1.6-4.8-3.9-4.9c-2.2-0.1-4.1,2-4.2,4.6c-0.1,2.6,1.6,4.8,3.9,4.9
				C357,397.3,358.9,395.3,359,392.7z"
            />
            <path
              fill={colour2}
              d="M351.5,383.8c-0.6-1.4-1.8-2.3-2.7-2.1c-0.9,0.3-1.2,1.7-0.6,3.1c0.6,1.4,1.8,2.3,2.7,2
				C351.8,386.6,352.1,385.2,351.5,383.8z"
            />
          </g>
          <path
            fill={colour0}
            d="M378.5,393.9c-3.7,0.2-13.5-21.2-34.1-22.1c-20.6-1-30.3,12.5-32.7,16.1c0,0-2.9-2.6,0.8-7.7
			c3.7-5.1,18.1-16.9,33.3-13.1c18,4.5,30.4,25.1,37.7,24.3L378.5,393.9z"
          />
          <path
            fill={colour6}
            d="M318,403c0,0,4.3,15.9,25.8,15.4c16.5-0.4,26.7-12.4,29.1-21c0,0-15.8,10.2-32.8,9.1
			C322.9,405.3,318,403,318,403z"
          />
          <path
            fill={colour0}
            d="M380.5,393c-10.8,4.3-18.5,20.6-43.8,17.3c-25.3-3.3-19.6-8.6-39.3-6.2c0,0,12.1-7.4,20.6-5
			c8.6,2.4,22.2,8.3,34.9,5.3C363.1,401.9,372.9,393,380.5,393z"
          />
          <path
            fill={colour0}
            d="M298.7,377.3c0,0,9.2,5.9,15.3,4.3l-2.2,2.6C311.8,384.3,303.2,384.2,298.7,377.3z"
          />
          <path
            fill={colour0}
            d="M296.8,387.1c0,0,10.7,2,15.8-1.8l-1,3.3C311.5,388.5,303.5,391.7,296.8,387.1z"
          />
          <path
            fill={colour0}
            d="M303.3,371.7c0,0,7.4,8,13.7,8l-2.8,2C314.3,381.7,305.9,379.5,303.3,371.7z"
          />
          <path
            fill={colour0}
            d="M307.7,367.8c0,0,6.7,8.6,13.1,9.1l-2.9,1.8C317.8,378.7,309.7,375.8,307.7,367.8z"
          />
          <path
            fill={colour0}
            d="M313.8,364c0,0,6,9.1,12.3,10.1l-3.1,1.5C323,375.6,315.1,372.1,313.8,364z"
          />
          <path
            fill={colour0}
            d="M321,360.4c0,0,2.3,8.5,7.2,9.3l-3,1.6C325.2,371.3,319.7,368.1,321,360.4z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            d="M490.8,386.5c0.7,3.5,1.9,12.9,6.2,15.3l-14-1.4C482.7,389.6,490.1,383,490.8,386.5z"
          />
          <g>
            <path
              fill={colour0}
              d="M482.8,393.1c2.8-0.8,7-4,7.1-5c0.1-1-9.2-9.5-9.2-9.5L482.8,393.1z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M431.3,398.6c-3-0.6-7.6-3.4-7.9-4.5c-0.2-1,7.1-10.1,7.1-10.1L431.3,398.6z"
            />
            <path
              fill={colour0}
              d="M428.8,393.9c-0.6-16.7,12.3-31.8,27.5-32.4c15.2-0.6,28,12.5,28.6,29.2c0.6,16.7-10.9,24.8-26.1,25.4
				C443.7,416.7,429.4,410.6,428.8,393.9z"
            />
            <path
              fill={colour2}
              d="M432.2,389.6c-0.5-14.4,10.4-25.8,24.5-25.5c14.1,0.3,25.9,12.2,26.4,26.6c0.5,14.4-10.5,23.3-24.6,23
				C444.5,413.4,432.7,403.9,432.2,389.6z"
            />
            <path
              fill={colour3}
              d="M457,410.3c14.1,0.3,25.1-9.4,24.5-23.7c-0.1-2.3-0.5-4.6-1.1-6.7c1.6,3.3,2.5,7,2.7,10.8
				c0.5,14.4-10.5,24-24.5,23.7c-11.9-0.2-22.2-7.6-25.4-18.6C437.4,404.5,446.6,410.1,457,410.3z"
            />
            <path
              fill={colour4}
              d="M444.5,392.4c-0.3-7.1,5.5-13.1,13-13.4c7.4-0.3,13.7,5.3,14,12.4c0.3,7.1-5.5,13.1-13,13.4
				C451,405,444.8,399.5,444.5,392.4z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M423.5,394c5.9-14.8,15.5-29.4,30.9-29.9c13.9-0.5,32,10.3,35,23.8C474.9,373.4,442.5,374.2,423.5,394z"
            />
            <path
              fill={colour6}
              d="M488.5,385.2c-3.1-10.9-37.8-27.1-63.7,5.8c0,0,4.1-29.8,30-30.8C485,359,488.5,385.2,488.5,385.2z"
            />
            <path
              fill={colour2}
              d="M464.3,395.8c-0.1-2.6,1.6-4.8,3.9-4.9c2.2-0.1,4.1,2,4.2,4.6c0.1,2.6-1.6,4.8-3.9,4.9
				C466.3,400.4,464.4,398.4,464.3,395.8z"
            />
            <path
              fill={colour2}
              d="M464,388c-0.8-1.3-0.8-2.8-0.1-3.4c0.8-0.6,2,0,2.8,1.3c0.8,1.3,0.8,2.8,0.1,3.4
				C466.1,389.9,464.8,389.3,464,388z"
            />
          </g>
          <path
            fill={colour0}
            d="M422.8,395c3.7,0.2,13.5-21.2,34.1-22.1c20.6-1,30.3,12.5,32.7,16.1c0,0,2.9-2.6-0.8-7.7
			c-3.7-5.1-18.1-16.9-33.3-13.1c-18,4.5-30.4,25.1-37.7,24.3L422.8,395z"
          />
          <path
            fill={colour6}
            d="M483.4,404c0,0-4.3,15.9-25.8,15.4c-16.5-0.4-26.7-12.4-29.1-21c0,0,15.8,10.2,32.8,9.1
			C478.4,406.3,483.4,404,483.4,404z"
          />
          <path
            fill={colour0}
            d="M420.8,394c10.8,4.3,18.5,20.6,43.8,17.3c25.3-3.3,19.6-8.6,39.3-6.2c0,0-12.1-7.4-20.6-5
			c-8.6,2.4-22.2,8.3-34.9,5.3C438.3,403,428.5,394.1,420.8,394z"
          />
          <path
            fill={colour0}
            d="M502.6,378.4c0,0-9.2,5.9-15.3,4.3l2.2,2.6C489.5,385.3,498.2,385.3,502.6,378.4z"
          />
          <path
            fill={colour0}
            d="M504.6,388.1c0,0-10.7,2-15.8-1.8l1,3.3C489.8,389.6,497.8,392.8,504.6,388.1z"
          />
          <path
            fill={colour0}
            d="M498.1,372.7c0,0-7.4,8-13.7,8l2.8,2C487.1,382.7,495.4,380.5,498.1,372.7z"
          />
          <path
            fill={colour0}
            d="M493.6,368.9c0,0-6.7,8.6-13.1,9.1l2.9,1.8C483.5,379.7,491.7,376.9,493.6,368.9z"
          />
          <path
            fill={colour0}
            d="M487.5,365c0,0-6,9.1-12.3,10.1l3.1,1.5C478.3,376.7,486.2,373.1,487.5,365z"
          />
          <path
            fill={colour0}
            d="M480.3,361.4c0,0-2.3,8.5-7.2,9.3l3,1.6C476.1,372.3,481.7,369.2,480.3,361.4z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_13;
